import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  h1{
    font-size: 24px;
  }
`;

export const ButtonCopy = styled.button`
  border: 0;
  width: 36px;
  height: 36px;
  padding: 4px;
  background: var(--color-button);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
  box-shadow: var(--shadow);

  svg{
    color: var(--color-white);
  }

  &:hover{
    background-color: var(--color-button-h);

    svg {

    }
  }

  @media (max-width: 767.98px) {
    position: fixed;
    width: 40px;
    height: 40px;

    z-index: 2;
   // bottom: 32px;
    right:26px;
  }

`;

export const ButtonPrint = styled.button`
  border: 0;
  width: 36px;
  height: 36px;
  padding: 4px;
  background: var(--color-button);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
  box-shadow: var(--shadow);

  svg{
    color: var(--color-white);
  }

  &:hover{
    background-color: var(--color-button-h);

    svg {

    }
  }

  @media (max-width: 767.98px) {
    position: fixed;
    width: 40px;
    height: 40px;

    z-index: 2;
   // bottom: 32px;
    right:26px;
  }

`;

export const ButtonReturn = styled.button`
  border: 0;
  width: 32px;
  height: 32px;
  padding: 4px;
  background: var(--color-button);
  border-radius: 50%;
  position: fixed;
  left:300px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;

  box-shadow: var(--shadow);
  svg{
    color: var(--color-white);
  }

  &:hover{
    background-color: var(--color-button-h);

    svg {

    }
  }


  @media (max-width: 767.98px) {
    position: fixed;
    width: 40px;
    height: 40px;

    z-index: 2;
   // bottom: 32px;
    left:26px;
  }

`;
